class SiteHeader extends HTMLElement {
  constructor() {
    super();

    this._selectors = {
      headerNav: '[js-header-nav]',
      whiteLogo: '[js-white-logo]',
      darkLogo: '[js-dark-logo]',
      whiteLogoDesktop: '[js-white-logo-desktop]',
      darkLogoDesktop: '[js-dark-logo-desktop]'
    }
  }

  connectedCallback() {
    this.headerNavs = document.querySelectorAll(this._selectors.headerNav);
    this.whiteLogo = this.querySelector(this._selectors.whiteLogo);
    this.darkLogo = this.querySelector(this._selectors.darkLogo);
    this.whiteLogoDesktop = this.querySelector(this._selectors.whiteLogoDesktop);
    this.darkLogoDesktop = this.querySelector(this._selectors.darkLogoDesktop);
    this._setListeners();
  }

  _setListeners(){
    document.addEventListener("scroll", this._headerBackground);
  }

  _headerBackground = evt => {
    var lastScrollTop = 0;
    var st = window.pageYOffset || document.documentElement.scrollTop;
    if (st > lastScrollTop) {
      this.headerNavs.forEach((nav) => {
        this.whiteLogo.classList.remove('active');
        this.darkLogo.classList.add('active');
        this.whiteLogoDesktop.classList.remove('active');
        this.darkLogoDesktop.classList.add('active');
        nav.classList.add('bkgrn-white-color-dark');
        nav.classList.remove('bkgrn-dark-color-white');
      });

    } else {
      this.headerNavs.forEach((nav) => {
        this.darkLogo.classList.remove('active');
        this.whiteLogo.classList.add('active');
        this.darkLogoDesktop.classList.remove('active');
        this.whiteLogoDesktop.classList.add('active');
        nav.classList.add('bkgrn-dark-color-white');
        nav.classList.remove('bkgrn-white-color-dark');
      });
    }
  }
}

customElements.define('section-header', SiteHeader)